import { render, staticRenderFns } from "./softList.vue?vue&type=template&id=60212a7a&scoped=true"
import script from "./softList.vue?vue&type=script&lang=js"
export * from "./softList.vue?vue&type=script&lang=js"
import style0 from "./softList.vue?vue&type=style&index=0&id=60212a7a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60212a7a",
  null
  
)

export default component.exports